import {useGetAutoDeliveryDetailsExtendedDcx} from '@/api/consumerApi';

const useSkipDelivery = () => {
    const {
        data: {autoDelivery, order},
    } = useGetAutoDeliveryDetailsExtendedDcx();

    return {autoDelivery, order};
};

export default useSkipDelivery;
